function Studiothink() {

  this.consts = {
    namespace: 'studiothink',
    breakpoints: {
      no: 0, 
      xs: 480,
      sm: 600,
      md: 782,
      lg: 960,
      xl: 1080,
      xxl: 1280,
      xxxl: 1440
    },
    breakpoint: 'md',
    breakpointNav: 'lg',
    transition: {
      fast: 275,
      medium: 400,
      slow: 650
    }
  };

  // this.observeElements = '#site-header > *, h1, h2, h3, h4, p, .wp-block-image, .frm_forms, #site-footer > .wp-block-group, .wp-block-button, .wp-block-st-fullwidth-content-slider__column, .wp-block-media-text__media, .wp-block-social-links, #site-footer .wp-block-column, .wp-block-query, hr, .post__filter, .wp-block-st-team-search, .team-hero__image-wrapper, .team-hero__actions, .team-bio-filter-row, .wp-block-st-accordion, .wp-block-st-social-share, .is-style-title-row, .wp-block-post-date, .wp-block-st-post-search, .wp-block-post-terms, .wp-block-st-author-detail, .wp-block-quote, .sidebar__links';
  this.observeElements = '';
  
  this.viewPort = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    scrollbarYWidth: window.innerWidth - document.documentElement.clientWidth,
    scrollbarXHeight: window.innerHeight - document.documentElement.clientHeight
  };
  this.uniqueIdLast = 0;
  
  this.header = {
    obj: document.querySelector( 'header.page-header' ),
    height: {
      no: 125,
      md: 163
    }
  }

  this.windowPageYOffsetLast = 0;

  var st = this;
  this.isSmallScreen = function( breakpoint ) {
    breakpoint = breakpoint || st.consts.breakpoint;
    return ( st.consts.breakpoints[ breakpoint ] > st.viewPort.width );
  };
  this.isSmallScreenNav = function() {
    return ( st.consts.breakpoints[ st.consts.breakpointNav ] > st.viewPort.width + st.viewPort.scrollbarYWidth );
  };
  
  this.resize = function() {

    st.viewPort = {
      width: document.documentElement.clientWidth,
      height: window.visualViewport.height,
      scrollbarYWidth: window.innerWidth - document.documentElement.clientWidth,
      scrollbarXHeight: window.innerHeight - document.documentElement.clientHeight
    }
    
    document.documentElement.style.setProperty('--vh',st.viewPort.height*.01+'px');
    document.documentElement.style.setProperty('--vw',st.viewPort.width*.01+'px');
    document.documentElement.style.setProperty('--sw',st.viewPort.scrollbarYWidth+'px');

    if ( !st.isSmallScreenNav() ) {

      if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );

    }
    
  };

  this.uniqueId = function( prefix ) {
    
    var id = '' + ++st.uniqueIdLast;
    return prefix ? prefix + id : 'st-' + id;
  };
    
  function init() {
    
    if ( window.st ) return false;

    document.documentElement.classList.add('st-initialized');
    if ( 'ontouchstart' in document.documentElement ) document.documentElement.classList.add('st-touch');
    if ( st.header.height.md <= window.pageYOffset ) document.documentElement.classList.add('st-scrolling');
    
    st.resize();
    
    return true;
  }
  init();
  
  window.st = window.st || this;
  
}
new Studiothink();

( function( $ ) {

  $( function() {

    // Ensure post template elements have the same height

    function equalizePostTemplateElements() {
      let categoryHeight = 0;
      let headingHeight = 0;
      let contentHeight = 0;
      let officeHeight = 0;
      $('.wp-block-post .wp-block-post-terms').css('min-height', 0);
      $('.wp-block-post .wp-block-post-title').css('min-height', 0);
      $('.wp-block-post .team-item__content').css('min-height', 0);
      $('.office-details').css('min-height', 0);
      if (window.innerWidth < 600) {
        return;
      }
      $('.wp-block-post').each(function() {
        if ($(this).find('.wp-block-post-terms').length > 0 && $(this).find('.wp-block-post-terms').height() > categoryHeight) {
          categoryHeight = $(this).find('.wp-block-post-terms').height();
        }
        if ($(this).find('.wp-block-post-title').length > 0 && $(this).find('.wp-block-post-title').height() > headingHeight) {
          headingHeight = $(this).find('.wp-block-post-title').height();
        }
        if ($(this).find('.team-item__content').length > 0 && $(this).find('.team-item__content').height() > contentHeight) {
          contentHeight = $(this).find('.team-item__content').height();
        }
      }).promise().done(function() {
        $('.wp-block-post .wp-block-post-terms').css('min-height', categoryHeight+'px');
        $('.wp-block-post .wp-block-post-title').css('min-height', headingHeight+'px');
        $('.wp-block-post .team-item__content').css('min-height', contentHeight+'px');
      });
      $('.office-details').each(function() {
        if ($(this).height() > officeHeight) {
          officeHeight = $(this).height();
        }
      }).promise().done(function() {
        $('.office-details').css('min-height', officeHeight+'px');
      });


    }
    

    st.resize();
    st.windowPageYOffsetLast = window.pageYOffset;

    equalizePostTemplateElements();

    $(window).on( 'load', function() { // ON LOAD 




    } ).on( 'resize orientationchange', function() { // ON RESIZE



      st.resize();

      equalizePostTemplateElements();
      
    } ).on( 'scroll', function( e ) { // ON SCROLL 

     

      if ( 0 === window.pageYOffset ) document.documentElement.classList.remove( 'is-scrolling' );
      else document.documentElement.classList.add( 'is-scrolling' );

      if ( 0 === window.pageYOffset || st.windowPageYOffsetLast < window.pageYOffset ) document.documentElement.classList.remove( 'is-scrolling-up' );
      else document.documentElement.classList.add( 'is-scrolling-up' );

      st.windowPageYOffsetLast = window.pageYOffset;

    } ).on( 'hashchange', function( e ) { // ON HASHCHANGE 
      
      if ( window.location.hash.match( /^#?!\// ) ) {
        
        e.preventDefault();
        st.hashParts = window.location.hash.replace( /\/$/, '').split('/');
        
        if ( 'string' === typeof st.hashParts[1] ) {
          
          if ( 'top' === st.hashParts[1] ) {
            
            $( 'html, body' ).stop( true ).animate( { scrollTop: 0 }, st.consts.transition.slow );
            history.replaceState( undefined, document.title, window.location.pathname );
            
          } else if ( 'start' === st.hashParts[1] ) {
            
            var $target = $( '#site-main > div:nth-child(2)' );
            $( 'html, body' ).stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow );
            history.replaceState( undefined, document.title, window.location.pathname );
            $target.focus();
            
          } else if ( 'undefined' === typeof st.hashParts[2] && $( '#' + st.hashParts[1] ).length ) {
            
            var $target = $( '#' + st.hashParts[1] );
            $('html, body').stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow, function() {
              
            } );
          
          } else if ( st.hashParts[1].length && 'string' === typeof st.hashParts[2] ) {
            
            if ( 0 < st.hashParts[2].length ) {
              
              switch( st.hashParts[1] ) {
                case 'modal':
                  var modal = document.getElementById( 'stmu-modal-content-' + st.hashParts[2] );
                  if ( modal && lity ) {
                    lity( modal );
                  }
                  history.replaceState( undefined, document.title, window.location.pathname );
                break;
              }

            }

          }

          if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );
          if ( document.documentElement.classList.contains( 'toggle-mobile-nav' ) ) document.documentElement.classList.remove( 'toggle-mobile-nav' );
          
        }
        return false;
      } else if (window.location.hash.match( /^#?/ ) && window.location.hash.length > 1) {
        e.preventDefault();

        if ( $( window.location.hash ).length ) {
            
          var $target = $( window.location.hash );
          $('html, body').stop( true ).animate( { scrollTop: $target.offset().top - st.header.height.md }, st.consts.transition.slow, function() {
            
          } );
          if ( document.documentElement.classList.contains( 'toggle-main-nav' ) ) document.documentElement.classList.remove( 'toggle-main-nav' );
          if ( document.documentElement.classList.contains( 'toggle-mobile-nav' ) ) document.documentElement.classList.remove( 'toggle-mobile-nav' );
        }
        
      }
      
    } ).trigger( 'scroll' );
    if ( window.location.hash.length ) $( window ).trigger( 'hashchange' );

    $( '[data-toggle-id]' ).on( 'click', function( e ) {
      
      e.preventDefault();

      var id = this.dataset.toggleId;
      
      if ( document.documentElement.classList.contains( 'toggle-' + id ) ) {
        document.documentElement.classList.remove( 'toggle-' + id );
        document.getElementById( id ).setAttribute('aria-expanded', false);
      } else {
        document.documentElement.classList.add( 'toggle-' + id );
        document.getElementById( id ).setAttribute('aria-expanded', true);
      }
      
    } );



    //lity on video link//
    $('a[href]:not([data-lity])').each( function() {
      var is_video = false;
      if ( 'string' === typeof this.href ) {
        if ( -1 !== this.href.indexOf( 'youtu.be' ) ) is_video = true;
        if ( -1 !== this.href.indexOf( 'youtube.com/watch' ) ) is_video = true;
        // if ( -1 !== this.href.indexOf( '.youtube.' ) ) is_video = true;
        if ( -1 !== this.href.indexOf( '.mp4' ) ) is_video = true;
        if ( -1 !== this.className.indexOf( 'button-video' ) ) is_video = true;
        if ( -1 !== this.parentNode.className.indexOf( 'button-video' ) ) is_video = true;
      }
      if ( true === is_video && 'function' === typeof lity ) {
        if ( -1 === this.className.indexOf( 'button-video' ) ) this.className += ' button-video';
        this.setAttribute( 'data-lity-extra' , 'true' );
      }
    } );
    $( document ).on( 'click', '[data-lity-extra]', lity);

    $('.wp-block-video > video').each( function() {

      var video = this, block = this.parentNode;
      video.controls = false;

      block.classList.add( 'play-me' );
      block.addEventListener( 'click', function( e ) {

        if ( !this.classList.contains( 'play-me' ) ) return;

        e.preventDefault();
        e.stopPropagation();

        this.classList.remove( 'play-me' );
        video.controls = true;
        video.play();

      } );

    } );

    if ( 'IntersectionObserver' in window ) {
  
      var parallaxOffsetTravel = function( element ) {

        this.element = element;
        let target = this;

        return function( event ) {

          var rect = target.element.getBoundingClientRect(), height = target.element.clientHeight;
          var offsetTop = rect.top + window.pageYOffset;
            
          var start = offsetTop - document.documentElement.clientHeight, end = offsetTop + height, distance = parseInt( target.element.dataset.parallaxDistance ), direction = target.element.dataset.parallaxDirection;
  
          if ( isNaN( distance ) ) distance = 100;
          if ( 'Y' !== direction ) direction = 'X';

          var travelDistance = rect.height * 2 + document.documentElement.clientHeight;
          var travelPosition = window.pageYOffset + document.documentElement.clientHeight - offsetTop;

          if ( 0 > travelPosition ) travelPosition = 0;
          if ( travelDistance < travelPosition ) travelPosition = travelDistance;

          var transformOffset = distance * ( travelPosition / travelDistance ) - ( distance / 2 );

          target.element.style.transform = 'translate' + direction + '(' + transformOffset + 'px)';

        } 
  
      }

      var observeSection = new IntersectionObserver( function( entries ) {
        
        entries.forEach( function( entry ) {
        
          var content = entry.target;
          
          if ( entry.isIntersecting ) {
            
            content.classList.add( 'intersected' );
            content.classList.add( 'intersecting' );

            if ( content.dataset.parallax && content.parallaxOffsetTravel ) window.addEventListener( 'scroll', content.parallaxOffsetTravel );

            if ( content.classList.contains( 'last-line' ) ) {
              content.parentNode.classList.add( 'intersected' );
            }

            if ( content.classList.contains( 'first-line' ) && content.parentNode.classList.contains( 'intersected' ) ) {
              content.parentNode.classList.remove( 'intersected' );
            }

          } else {

            content.classList.remove( 'intersecting' );

            if ( content.dataset.parallax && content.parallaxOffsetTravel ) window.removeEventListener( 'scroll', content.parallaxOffsetTravel );

          }
          
        });
        
      } ); 
      
      // Standard fade-in and slide-up.
      if ( typeof st.observeElements === 'string' && st.observeElements.trim() !== '' ) {
        var contentNodes = document.querySelectorAll( st.observeElements );
        for( var i = 0; i < contentNodes.length; i++ ) {

          if (!contentNodes[i].closest('.observing')) {

            contentNodes[i].classList.add( 'observing' );
            if ( 0 !== window.pageYOffset ) contentNodes[i].classList.add( 'intersected' );
            else observeSection.observe( contentNodes[i] );

            if ( contentNodes[i].classList.contains( 'last-line' ) ) {
              contentNodes[i].parentNode.classList.add( 'observing' );
              if ( 0 !== window.pageYOffset ) contentNodes[i].parentNode.classList.add( 'intersected' );
            }
          }
          
        }
      }

      // Parallax effects.
      var contentNodes = document.querySelectorAll( '.parallax-el' );
      for( var i = 0; i < contentNodes.length; i++ ) {

        contentNodes[i].dataset.parallax = true;

        if ( contentNodes[i].classList.contains( 'image-1' ) ) {
          contentNodes[i].dataset.parallaxDistance = -150;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else if ( contentNodes[i].classList.contains( 'image-2' ) ) {
          contentNodes[i].dataset.parallaxDistance = 200;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else if ( contentNodes[i].parentNode.classList.contains( 'line-1' ) ) {
          contentNodes[i].dataset.parallaxDistance = 25;
          contentNodes[i].dataset.parallaxDirection = 'X';
        } else if ( contentNodes[i].parentNode.classList.contains( 'line-2' ) ) {
          contentNodes[i].dataset.parallaxDistance = -25;
          contentNodes[i].dataset.parallaxDirection = 'X';
        } else if ( contentNodes[i].parentNode.classList.contains( 'line-3' ) ) {
          contentNodes[i].dataset.parallaxDistance = -50;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else if ( contentNodes[i].classList.contains( 'compass-graphic' ) ) {
          contentNodes[i].dataset.parallaxDistance = 100;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        } else {
          contentNodes[i].dataset.parallaxDistance = 200;
          contentNodes[i].dataset.parallaxDirection = 'Y';
        }

        contentNodes[i].parallaxOffsetTravel = new parallaxOffsetTravel( contentNodes[i] );
        observeSection.observe( contentNodes[i] );
        
      }
      
    }

    // Add classes and ID to page  sections
    let sectionCount = 1;
    $('#site-main').children('.wp-block-cover, .wp-block-columns, .wp-block-group').each(function() {
      $(this).addClass('section-'+sectionCount);
      if (!$(this).attr('id')) {
        $(this).attr('id', 'section-'+sectionCount);
      }
      sectionCount++;
    });
    // Rewrite scroll down arrow href on hero to next section id
    $('.studiothink-scroll-down').each(function() {
      let thisSection = $(this).closest('.is-style-hero');
      let nextSiblingAnchor = '#' + thisSection.next().attr('id');
      $(this).attr('href', nextSiblingAnchor);
    });

  //  Select 2
    const $select2Elements = $('.select2:not(.post-filter__field)').find('select');
    if ($select2Elements.length > 0) {
      $select2Elements.select2({
        minimumResultsForSearch: Infinity,
        dropdownAutoWidth: true,
        theme: "flat",
        allowClear: true,
        templateResult: select2Format
      });
    }
    
    function select2Format (item, container) {
      let state = item.text; 
        if ($(item.element).hasClass('has-parent')) {
          $(container).hide();
        }
        
        return state;
    };


    // handle form field labels
    $('.frm_form_field input, .frm_form_field select, .frm_form_field textarea').on('change', function() {
      if ($(this).val().length > 0) {
        $(this).parent().addClass("has-val");
      } else {
        $(this).parent().removeClass("has-val");
      }
    });


    if($('.wp-block-table').length > 0) {

      $('.wp-block-table').each(function() {
        let $thisTable = $(this);
        let columnLabels = [];

        $thisTable.find('th').each(function() {
          columnLabels.push($(this).text());
        }).promise().done(function() {
          $thisTable.find('tbody tr').each(function() {
  
            $(this).find('td').each(function(i) {
              $(this).attr('data-label', columnLabels[i]);
            });
          });

        });

      });
    }

    function handleLongButtons() {
      $('.wp-block-button__text__initial').each(function() {
        let textHeight = $(this).outerHeight();
        let $textWrap = $(this).closest('.wp-block-button__text');
        if ($textWrap.length > 0) {
          $textWrap.css('height', textHeight + 'px');
        }
      });
    }

    function checkButtonHeight() {
      if ($('.wp-block-buttons').length > 0) {
        $('.wp-block-buttons').each(function() {
          let buttonHeight = 50;
          let thisHeight = $(this).outerHeight();
          if ($(this).find('.wp-block-button').length > 0) {
            buttonHeight = $(this).find('.wp-block-button').outerHeight();
          }
  
          if (thisHeight >= (buttonHeight * 2)) {
            $(this).addClass('buttons-wrapped');
          } else {
            $(this).removeClass('buttons-wrapped');
          }
        });
      }
    }

    handleLongButtons();
    checkButtonHeight();

    $(window).on('resize', function() {
      handleLongButtons();
      checkButtonHeight();
    });
    

      
  } );

} )( jQuery );
